import { ToastType } from '@components/toast';
import { QuoteDeclarationPostRequestBody, QuoteDeclarationPostResponse } from '@lio/api-types';
import { quoteDeclarationQueryKeys } from '@services/quotes/quoteDeclaration/keys';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useClient } from '@utils/api-client';
import { getApiErrorMessage } from '@utils/getApiErrorMessage';
import { useSnackbar } from 'notistack';

export const useCreateQuoteDeclaration = (quoteId: string) => {
  const client = useClient();
  const queryClient = useQueryClient();
  const { enqueueSnackbar } = useSnackbar();

  const mutationFn = async (requestBody: QuoteDeclarationPostRequestBody) =>
    client
      .post(`quote/${quoteId}/quote-declaration`, {
        json: requestBody,
      })
      .json<QuoteDeclarationPostResponse>();

  const result = useMutation({
    mutationFn,
    onSuccess: (data) => {
      queryClient.invalidateQueries({
        predicate: (query) => query.queryKey.includes(quoteDeclarationQueryKeys.search[0]),
      });
      return data;
    },
    onError: async (e) => {
      const message = await getApiErrorMessage(e, 'An error occurred');
      enqueueSnackbar(message, {
        variant: ToastType.Error,
      });
    },
  });
  return { ...result, createQuoteDeclaration: result.mutateAsync };
};
